import {Component} from 'react'
import { parseISO, isAfter, addMonths, differenceInYears, differenceInMonths } from 'date-fns'
import scrollToElement from '../../../../services/scrollTo.js'

import './Missions.scss'

class MissionSummary extends Component {
  constructor(props) {
    super(props)
    this.state = {
      experiences: this.getSortedMissions(this.props.freelance?.experiences?.length ? this.props.freelance.experiences : []),
    }
  }

  componentDidUpdate(prevProps, prevState, prevContext) {
    if (this.props.freelance && this.props.freelance.id !== prevProps.freelance.id) {
      this.setState({
        experiences: this.getSortedMissions(this.props.freelance?.experiences?.length ? this.props.freelance.experiences : [])
      })
    }
  }

  getSortedMissions = (experiences) => {
    return experiences
      .sort((a, b) => {
        if (a.current && !b.current) {
          return -1
        }

        if (b.current && !a.current) {
          return 1
        }

        const dateA = parseISO(a.start)
        const dateB = parseISO(b.start)
        if (dateA && dateB) {
          if (isAfter(dateA, dateB)) {
            return -1
          } else {
            return 1
          }
        } else {
          return 0
        }
      })
      .map((experience) => {

        let end = null
        let start = new Date(experience.start)

        if(experience.end) {
          end = new Date(experience.end)
        }

        if(experience.start) {
          start = new Date(experience.start)
        }

        if(experience.current) {
          end = new Date()
        }

        if(!start || !end) {
          return experience
        }

        end = addMonths(end, 1)
        const yearsDiff = differenceInYears(end, start)
        const monthsDiff = differenceInMonths(end, addMonths(start, yearsDiff * 12))

        if(yearsDiff) {
          if(monthsDiff) {
            experience.dateFormat = `${yearsDiff} ans et ${monthsDiff} mois`
          } else {
            experience.dateFormat = `${yearsDiff} ans`
          }
        } else if(monthsDiff) {
          experience.dateFormat = `${monthsDiff} mois`
        }

        return experience
      })

  }

  onClick = (id) => {
    scrollToElement(`#experiences-${id}`)
  }

  render() {
    return (
      <div>
        {this.state.experiences.map((experience, offset) => {
          return (
            <div className={`${this.props.className} clickable page-break-inside`} key={offset} onClick={() => this.onClick(offset)}>
              {(experience.title || experience.locality || experience.company) && (
                <div className="mission-block">
                  <div className="unit">
                    {<div className={'mobile-break-all'}>
                      <h3 className="sub-sub-title mobile-break-all">{experience.title}</h3>
                      {experience.locality && <span className="locality">{experience.locality}</span>}</div>}
                    {experience.company && <div className={'mobile-break-all'}>{experience.company}
                    </div>}
                  </div>
                  <div className="unit date">
                    {experience.dateFormat}
                  </div>
                </div>)}
            </div>
          )})}
      </div>
    )
  }
}

export default MissionSummary